document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-ss-gallery]').forEach(function(gallery){
    var mains = Array.prototype.slice.call(gallery.querySelectorAll('[data-ss-gallery-main]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ss-gallery-thumb]'));
    var prevs = gallery.querySelectorAll('[data-ss-gallery-prev]');
    var nexts = gallery.querySelectorAll('[data-ss-gallery-next]');
    if (!mains.length) return;
    var active = 0;
    function show(index){
      active = (index + mains.length) % mains.length;
      mains.forEach(function(img, i){ img.classList.toggle('is-hidden', i !== active); });
      thumbs.forEach(function(btn, i){
        btn.classList.toggle('is-active', i === active);
        if (i === active) btn.scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
      });
    }
    thumbs.forEach(function(btn){ btn.addEventListener('click', function(){ show(parseInt(btn.getAttribute('data-ss-gallery-thumb'), 10) || 0); }); });
    prevs.forEach(function(btn){ btn.addEventListener('click', function(){ show(active - 1); }); });
    nexts.forEach(function(btn){ btn.addEventListener('click', function(){ show(active + 1); }); });
  });
});
